import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Complement, Variation } from '../../interface/view-product.interface';
import { LoaderGeneralComponent } from "../../../../../../shared/components/loader-general/loader-general.component";
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'modal-view-complements-variations',
  standalone: true,
  imports: [FormsModule, LoaderGeneralComponent, CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './complements-variations.component.html',
  styleUrl: './complements-variations.component.css'
})
export class ComplementsVariationsComponent implements OnInit, OnChanges {
  @Input() variations: Variation[] = [];
  @Input() complements: Complement[] = [];
  @Input() loading: boolean = false;
  @Output() selectionChanged = new EventEmitter<void>();


  // Propiedades para almacenar las selecciones del usuario
  // Objeto para almacenar las opciones seleccionadas de variaciones
  selectedOptions: {[key: string]: string} = {};
  // Array para almacenar los complementos seleccionados
  selectedComplements: string[] = [];
  // Objeto para controlar el estado de colapso de las secciones
  collapsedSections: {[key: string]: boolean} = {};

  ngOnInit() {
    // console.log('complementos totales', this.complements);
    this.initializeDefaultOptions();
    this.initializeCollapsedSections();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Cuando cambian las variaciones o complementos desde el componente padre
    if (changes['variations'] || changes['complements']) {
      this.initializeDefaultOptions();
      this.initializeCollapsedSections();
    }
  }

  /**
   * Inicializa las opciones por defecto para las variaciones
   */
  initializeDefaultOptions() {
    if (this.variations && this.variations.length > 0) {
      this.variations.forEach(variation => {
        const defaultOption = variation.options.find(opt => opt.isDefault === true);
        if (defaultOption) {
          this.selectedOptions[variation.variation_id] = defaultOption.variationOption_id;
        } else {
          // Si no hay opción por defecto, seleccionar la primera
          if (variation.options.length > 0) {
            this.selectedOptions[variation.variation_id] = variation.options[0].variationOption_id;
          }
        }
      });
      // Emitir evento después de inicializar las opciones por defecto
      setTimeout(() => {
        this.selectionChanged.emit();
      }, 0);
    }
  }

  /**
   * Inicializa el estado de colapso de las secciones
   * Por defecto, todas las secciones están colapsadas
   */
  initializeCollapsedSections() {
    // Inicializar secciones de variaciones
    if (this.variations && this.variations.length > 0) {
      this.variations.forEach(variation => {
        this.collapsedSections['variation_' + variation.variation_id] = true;
      });
    }
    // Inicializar sección de complementos
    this.collapsedSections['complements'] = true;
  }

  /**
   * Alterna el estado de colapso de una sección
   * @param sectionId ID de la sección a alternar
   */
  toggleSection(sectionId: string) {
    this.collapsedSections[sectionId] = !this.collapsedSections[sectionId];
  }

  /**
   * Verifica si una sección está colapsada
   * @param sectionId ID de la sección a verificar
   * @returns true si la sección está colapsada, false en caso contrario
   */
  isSectionCollapsed(sectionId: string): boolean {
    return this.collapsedSections[sectionId] === true;
  }

  /**
   * Alterna la selección de un complemento
   * @param complementId ID del complemento a alternar
   */
  toggleComplement(complementId: string) {
    const index = this.selectedComplements.indexOf(complementId);
    if (index > -1) {
      this.selectedComplements.splice(index, 1);
    } else {
      this.selectedComplements.push(complementId);
    }
    // Emitir evento cuando cambian las selecciones
    this.selectionChanged.emit();
  }

  /**
   * Verifica si un complemento está seleccionado
   * @param complementId ID del complemento a verificar
   * @returns true si el complemento está seleccionado, false en caso contrario
   */
  isComplementSelected(complementId: string): boolean {
    return this.selectedComplements.includes(complementId);
  }

  /**
   * Obtiene todas las selecciones actuales (variaciones y complementos)
   * @returns Objeto con las selecciones actuales
   */
  getSelections() {
    return {
      selectedVariations: this.selectedOptions,
      selectedComplements: this.selectedComplements
    };
  }
}
